import { MenuItemDto } from "./types";

export const MenuConfiguration: MenuItemDto[] = [
    {
        key: 'tickets',
        title: 'Билеты',
        icon: null,
        url: 'https://tickets.fcrodina.com'
    },
    {
        key: 'shop',
        title: 'Магазин',
        icon: null,
        url: 'https://shop.fcrodina.com'
    },
    {
        key: 'home',
        title: 'Главная',
        url: '/rodina/'
    },
    {
        key: 'news',
        title: 'Новости',
        children: [
            {
                key: 'mainNews',
                title: 'Главные события',
                url: '/news/'
            },
            {
                key: 'timeline',
                title: 'Информационная лента',
                url: '/timeline/'
            },
            {
                key: 'digest',
                title: 'СМИ о «Родине»',
                url: '/news/digest/'
            },
        ],
    },
    {
        key: 'stats',
        title: 'Матчи',
        children: [
            {
                key: 'calendar',
                title: 'Календарь',
                url: '/games/'
            },
            {
                key: 'tables',
                title: 'Таблица',
                url: '/tables/'
            },
            {
                key: 'players',
                title: 'Статистика игроков',
                url: '/games/stat/'
            },
        ],
    },
    /*{
        key: 'my',
        title: 'Моя родина',
        children: [
            {
                key: 'matchday',
                title: 'Матчдей',
                url: '/matchday/'
            },
            {
                key: 'contests',
                title: 'Города Родины',
                url: '/goroda/'
            },
           {
                key: 't-design',
                title: 'Моя футболка',
                url: '/design/'
            },
            {
                key: 'fan-app',
                title: 'Приложение болельщика',
                url: '/fan-app/'
            }
        ],
    },*/
    {
        key: 'team',
        title: 'Команда',
        children: [
            {
                key: 'temaPlayers',
                title: 'Игроки',
                url: '/team/'
            },
            {
                key: 'trainers',
                title: 'Тренерский штаб',
                url: '/club/trainers/'
            },
            {
                key: 'club100',
                title: 'Клуб 100 Георгия Юдинцева',
                url: '/team/club-100/'
            },
        ],
    },
    {
        key: 'club',
        title: 'Клуб',
        url: '/club/',
        children: [
            {
                key: 'management',
                title: 'Менеджмент',
                url: '/club/management/'
            },
            {
                key: 'jobs',
                title: 'Вакансии',
                url: '/jobs/'
            },
            {
                key: 'stadium',
                title: 'Стадион',
                url: '/stadium/'
            },
            {
                key: 'partners',
                title: 'Партнеры',
                url: '/partners/'
            },
            {
                key: 'contacts',
                title: 'Контакты',
                url: '/club/contacts/'
            }
        ],
    },
    {
        key: 'rodina-2',
        title: 'Родина-2',
        url: '/2/'
    },
    {
        key: 'rodina-3',
        title: 'Родина-3',
        url: '/3/'
    },
    {
        key: 'rodina-m',
        title: 'Молодёжка',
        url: 'https://academy.fcrodina.com/youth/'
    },
    {
        key: 'academy',
        title: 'Академия',
        url: 'https://academy.fcrodina.com'
    },
]